import { render, staticRenderFns } from "./eDSWork.vue?vue&type=template&id=5690a020"
import script from "./eDSWork.vue?vue&type=script&lang=js"
export * from "./eDSWork.vue?vue&type=script&lang=js"
import style0 from "./eDSWork.vue?vue&type=style&index=0&id=5690a020&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports